(function(){
  document.querySelectorAll('[data-ctfb]').forEach(function(root){
    var grid=root.querySelector('.ctfb__grid'); if(!grid) return;
    var all=[].slice.call(grid.querySelectorAll('.ctfb__card'));
    var builds=all.filter(function(c){return c.dataset.kind!=='wheel'}), wheels=all.filter(function(c){return c.dataset.kind==='wheel'});
    var step=parseInt(root.getAttribute('data-step')||'24',10), every=parseInt(root.getAttribute('data-every')||'12',10), shown=step, active={};
    var more=root.querySelector('[data-more]'), count=root.querySelector('[data-count]'), sort=root.querySelector('[data-sort]');
    function match(c){for(var k in active){if(k==='kind'||!active[k])continue;if((c.getAttribute('data-'+k)||'').split('|').indexOf(active[k])<0)return false}return true}
    function render(){
      all.forEach(function(c){c.hidden=true});
      var onlyWheels=active.kind==='wheel', filtered=false;
      for(var k in active){if(k!=='kind'&&active[k])filtered=true}
      var order=[];
      if(onlyWheels){
        var ws=wheels.filter(match);ws.forEach(function(w){order.push(w);w.hidden=false});
        if(count)count.textContent=ws.length+(ws.length===1?' wheel':' wheels');
        if(more)more.hidden=true;
      }else{
        var bs=builds.filter(match),wi=0;
        bs.forEach(function(b,i){
          order.push(b);b.hidden=i>=shown;
          if(!filtered&&(i+1)%every===0&&i<shown&&wi<wheels.length){var w=wheels[wi++];order.push(w);w.hidden=false}
        });
        if(count)count.textContent=bs.length+(bs.length===1?' build':' builds');
        if(more)more.hidden=bs.length<=shown;
      }
      order.forEach(function(c){grid.appendChild(c)});
    }
    root.querySelectorAll('.ctfb-chip').forEach(function(ch){
      ch.addEventListener('click',function(){
        var g=ch.getAttribute('data-group'),v=ch.getAttribute('data-value');
        active[g]=(active[g]===v||v==='')?null:v;
        root.querySelectorAll('.ctfb-chip[data-group="'+g+'"]').forEach(function(o){o.setAttribute('aria-pressed',String((o.getAttribute('data-value')||'')===(active[g]||'')))});
        var wl=root.querySelector('[data-wlink]');
        if(wl&&g==='model'){var u=active[g]?ch.getAttribute('data-url'):'';if(u){wl.href=u;wl.textContent='View '+v+' wheel page →';wl.hidden=false}else{wl.hidden=true}}
        shown=step;render();
      });
    });
    function sortBy(key){
      builds.sort(function(a,b){
        if(key==='featured'){var f=(+b.dataset.featured)-(+a.dataset.featured);if(f)return f}
        return (+b.dataset.sort)-(+a.dataset.sort);
      });
    }
    if(sort)sort.addEventListener('change',function(){sortBy(sort.value);shown=step;render()});
    sortBy(sort?sort.value:'newest');
    if(more)more.addEventListener('click',function(){shown+=step;render()});
    var dds=[].slice.call(root.querySelectorAll('[data-dd]'));
    function closeAll(except){dds.forEach(function(d){if(d===except)return;var b=d.querySelector('.ctfb__ddbtn'),p=d.querySelector('.ctfb__ddpanel');b.setAttribute('aria-expanded','false');p.hidden=true;d.classList.remove('is-open')})}
    dds.forEach(function(d){
      var b=d.querySelector('.ctfb__ddbtn'),p=d.querySelector('.ctfb__ddpanel'),lab=d.querySelector('[data-ddlabel]');
      b.addEventListener('click',function(e){e.stopPropagation();var o=b.getAttribute('aria-expanded')!=='true';closeAll(d);b.setAttribute('aria-expanded',String(o));p.hidden=!o;d.classList.toggle('is-open',o);if(o){var f=p.querySelector('[aria-selected=true]')||p.firstElementChild;f&&f.focus()}});
      p.addEventListener('click',function(e){e.stopPropagation()});
      p.querySelectorAll('[role=option]').forEach(function(o){o.addEventListener('click',function(){
        p.querySelectorAll('[role=option]').forEach(function(x){x.setAttribute('aria-selected',String(x===o))});
        var v=o.getAttribute('data-value'),sv=o.getAttribute('data-sortval');
        if(sv){if(sort){sort.value=sv;sort.dispatchEvent(new Event('change'))}lab.textContent=sv==='newest'?lab.getAttribute('data-default'):o.textContent;d.classList.toggle('is-set',sv!=='newest')}
        else{var g=o.getAttribute('data-group'),on=!!active[g];lab.textContent=on?(g==='model'?o.textContent.replace(/^CTF\w+\s+/,''):o.textContent):lab.getAttribute('data-default');d.classList.toggle('is-set',on)}
        closeAll();b.focus();
      })});
      p.addEventListener('keydown',function(e){var os=[].slice.call(p.querySelectorAll('[role=option]')),i=os.indexOf(document.activeElement);if(e.key==='ArrowDown'){e.preventDefault();(os[i+1]||os[0]).focus()}if(e.key==='ArrowUp'){e.preventDefault();(os[i-1]||os[os.length-1]).focus()}});
    });
    document.addEventListener('click',function(){closeAll()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});
    render();
  });
  document.querySelectorAll('[data-ctfb-car]').forEach(function(car){
    var t=car.querySelector('.ctfb-car__track'),dots=car.querySelectorAll('.ctfb-car__dots span');
    function idx(){return Math.round(t.scrollLeft/t.clientWidth)}
    t.addEventListener('scroll',function(){var i=idx();dots.forEach(function(d,j){d.classList.toggle('is-on',i===j)})},{passive:true});
    car.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){t.scrollBy({left:t.clientWidth*(+b.dataset.dir),behavior:'smooth'})})});
  });
})();
